import StorageSvcMod from '@Services/Storage.svc.js';
/** @typedef {import('./StorageState.svc')} Types */
//
export class StateStorage {
	constructor($q, $log, StorageSvc, $state, ENV) {
		'ngInject';
		this.envKey = `${ENV}_ENV`;
		this.$q = $q;
		this.$log = $log;
		this.storageService = StorageSvc;
		this.state = $state;
		this.prefix = '';
	}

	/**
	 * @param {string} stateName
	 * @returns {string}
	 */
	genUiKey(stateName) {
		const _keyByState = stateName.replace('.', '_');
		const _prefix = this.prefix ? `${this.prefix}_` : '';
		return `${_prefix}${_keyByState}`;
	}

	/**
	 * @param {Types.UiStatePatch} params
	 * @param {string} [instanceId]
	 * @returns {Types.UiStatePatch}
	 */
	setUiState(params, instanceId) {
		const baseKey = this.genUiKey(this.state.current.name);
		const stateKey = instanceId ? `${baseKey}_${instanceId}` : baseKey;
		const storedObj = this.storageService.get(this.envKey) || {};

		if (!storedObj[stateKey]) storedObj[stateKey] = {};

		Object.assign(storedObj[stateKey], params);

		this.storageService.set(this.envKey, storedObj);
		return storedObj[stateKey];
	}

	/**
	 * Overlay route/query params onto stored UI state (params win when truthy),
	 * persist, and return the merged state. Centralizes the per-page merge idiom.
	 * @param {Types.UiStatePatch} paramMap
	 * @param {string} [instanceId]
	 * @returns {Types.UiStatePatch}
	 */
	mergeUiState(paramMap = {}, instanceId) {
		const stored = this.getUiState(instanceId);
		const overlay = Object.entries(paramMap).reduce((acc, [key, value]) => {
			acc[key] = value != null && value !== '' ? value : stored[key];
			return acc;
		}, {});
		return this.setUiState(overlay, instanceId);
	}

	/**
	 * @param {string} [instanceId]
	 * @returns {Types.UiStatePatch}
	 */
	getUiState(instanceId) {
		const baseKey = this.genUiKey(this.state.current.name);
		const stateKey = instanceId ? `${baseKey}_${instanceId}` : baseKey;
		const storeData = this.storageService.get(this.envKey) || {};

		return storeData[stateKey] || {};
	}

	/**
	 * @param {string} [instanceId] pass 'all' to clear the whole env bucket
	 * @returns {void}
	 */
	clearUiState(instanceId) {
		if (instanceId === 'all') {
			this.storageService.remove(this.envKey);
			return;
		}

		const baseKey = this.genUiKey(this.state.current.name);
		const stateKey = instanceId ? `${baseKey}_${instanceId}` : baseKey;
		const storedObj = this.storageService.get(this.envKey) || {};

		delete storedObj[stateKey];
		this.storageService.set(this.envKey, storedObj);
	}
}
//
let compMod = angular
	.module('mod.svc.StorageStateSvc', [StorageSvcMod])
	.service('StorageStateSvc', StateStorage);
export default (compMod = compMod.name);
